import { SyncEventType } from '../../enums/syncEventType';
import { ChatEvent } from './chatEvent';

export class EventMessageCreated implements ChatEvent {
  public readonly type = SyncEventType.MESSAGE_CREATED;

  public content: string;
  public timestamp: Date;
  public channel_id: number;
  public sender_id: string;
  public is_ki_ignored: boolean;
  public is_read: boolean;
  public issue_id: number | null;

  constructor({
    content,
    timestamp,
    channel_id,
    sender_id,
    is_ki_ignored,
    is_read,
    issue_id = null,
  }: {
    content: string;
    timestamp: Date;
    channel_id: number;
    sender_id: string;
    is_ki_ignored: boolean;
    is_read: boolean;
    issue_id?: number;
  }) {
    this.content = content;
    this.timestamp = timestamp;
    this.channel_id = channel_id;
    this.sender_id = sender_id;
    this.is_ki_ignored = is_ki_ignored;
    this.is_read = is_read;
    this.issue_id = issue_id;
  }

  getPayload(): object {
    return {
      content: this.content,
      timestamp: this.timestamp,
      channel_id: this.channel_id,
      sender_id: this.sender_id,
      is_ki_ignored: this.is_ki_ignored,
      is_read: this.is_read,
      issue_id: this.issue_id,
    };
  }
}
